import { createAsyncAction } from 'typesafe-actions';
import { TeamUpTheme } from './themeTypes';

export const loadThemeAsync = createAsyncAction(
    'LOAD_THEME_REQUEST',
    'LOAD_THEME_SUCCESS',
    'LOAD_THEME_FAILURE',
)<void, TeamUpTheme, string>();
